import {NotificationProps, Notification, Typography, Divider, Button} from '@genestack/ui';
import * as React from 'react';
import {NotificationsCenter} from './notifications-center';

export type NotificationElement = React.ReactElement<NotificationProps>;

export function showNotification(notification: NotificationElement) {
    return NotificationsCenter.addNotification
        ? NotificationsCenter.addNotification(notification)
        : () => null;
}

export function showErrorNotification(title = 'Request error, try again later') {
    return (error: unknown) => {
        showNotification(
            <Notification countdown="none">
                <Typography intent="alarm">{title}</Typography>
                {error instanceof Error && <Typography>{error.message}</Typography>}
            </Notification>
        );
    };
}

export function showWarningNotification(title: string) {
    showNotification(
        <Notification countdown="active">
            <Typography intent="warning">{title}</Typography>
        </Notification>
    );
}

interface UndoBtnProps {
    onClick: () => void;
    disabled?: boolean;
}

interface SuccessNotificationProps {
    title: string;
    label?: string;
    undoBtnProps?: UndoBtnProps;
    onClose?: () => void;
}

export function NotificationWithBtn(props: SuccessNotificationProps) {
    return (
        <Notification onClose={props.onClose}>
            <Typography intent="success" variant="section">
                {props.title}
            </Typography>
            {props.label && <Typography>{props.label}</Typography>}

            {props.undoBtnProps && (
                <React.Fragment>
                    <Divider variant="transparent" />

                    <Button
                        intent="accent"
                        size="small"
                        onClick={props.undoBtnProps.onClick}
                        disabled={props.undoBtnProps.disabled}
                    >
                        Undo
                    </Button>
                    <Divider variant="transparent" />
                </React.Fragment>
            )}
        </Notification>
    );
}
